import React from 'react';
 
const ProjectPathProvider = React.createContext(null);
 
export default ProjectPathProvider;